import { useEffect, useState } from 'react';

/**
 * Detecta el tema actual (claro/oscuro) observando la clase 'dark' en <html>.
 * Útil para gráficos de canvas (Chart.js) que no reciben variantes `dark:` de Tailwind.
 * Devuelve `true` en modo oscuro, `false` en modo claro.
 */
export default function useIsDarkMode() {
  const [isDark, setIsDark] = useState(() =>
    typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const root = document.documentElement;
    const sync = () => setIsDark(root.classList.contains('dark'));
    sync();

    const observer = new MutationObserver(sync);
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  return isDark;
}
